import {MyRemedialsComponent} from "./my-remedials.component";
import {Routes} from "@angular/router";
import {RemedialDetailsComponent} from "./remedial-details/remedial-details.component";

export const myRemedialsRoutes: Routes = [
  {path: '', component: MyRemedialsComponent},
  { path: ':id', component: RemedialDetailsComponent }
];
